module.exports = __webpack_public_path__ + "img/serifnew_box20.4ef38842.jpg";